import { render, staticRenderFns } from "./product-dialog-selector.vue?vue&type=template&id=9fa43ecc&"
import script from "./product-dialog-selector.vue?vue&type=script&lang=js&"
export * from "./product-dialog-selector.vue?vue&type=script&lang=js&"
import style0 from "./product-dialog-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports